import React, { FC } from 'react';

import useCompany, { useCompanyType } from 'hooks/api/useCompany';
import { isRestrictedEditAo, KeyCardsEnum } from 'components/forms/ActivationOrderForm/CardsAo/data';

import { paramsObjAO } from '../../ActivationOrderForm';
import ItemsAo from '../ItemsAo';

interface CardFutureReceivablesType {
  params?: paramsObjAO;
}

const CardFuture: FC<CardFutureReceivablesType> = React.memo(() => {
  const { aoFormData }: useCompanyType = useCompany();
  const isRestrictedAo = isRestrictedEditAo(aoFormData?.ao_type, aoFormData?.status);

  return (
    <>
      <ItemsAo disabled={isRestrictedAo} types={[KeyCardsEnum.AO_DATE, KeyCardsEnum.AO_NUMBER]} />
      <ItemsAo disabled={isRestrictedAo} types={[KeyCardsEnum.PENALTY_POLICY, KeyCardsEnum.CURRENCY]} />
      <ItemsAo disabled={isRestrictedAo} types={[KeyCardsEnum.AMOUNT, KeyCardsEnum.PURCHASED_RECEIVABLES]} />
      <ItemsAo disabled={isRestrictedAo} types={[KeyCardsEnum.PERIOD, KeyCardsEnum.PURCHASE_DATE]} />
      <ItemsAo types={[KeyCardsEnum.FIRST_REPAYMENT_DATE, KeyCardsEnum.FINAL_REPAYMENT_DATE]} />

      <ItemsAo disabled={isRestrictedAo} types={[KeyCardsEnum.DISTRIBUTION_PLATFORMS_FA_CREATE]} />
      <ItemsAo disabled={isRestrictedAo} types={[KeyCardsEnum.PAYMENT_PLAN]} />

      <ItemsAo types={[KeyCardsEnum.AO_FUTURE_CUSTOM_SETTINGS]} />
    </>
  );
});

export default CardFuture;
